import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropDownConstantsFactory } from '../../../base/shared/syncfusion/dropdown-constants-factory';
import { EnumTranslationService } from '../../../base/services/enum-translation.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../../base/services/auth.service';
import { ReportType, Role } from '../../../base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceStatusFormComponent } from '../report/device-status/device-status-form/device-status-form.component';
import { ParkerExtractFormComponent } from '../report/parker-extract/parker-extract-form/parker-extract-form.component';
import { ParkerTurnoverFormComponent } from '../report/parker-turnover/parker-turnover-form/parker-turnover-form.component';
import { FalseRecordingFormComponent } from '../report/false-recording/false-recording-form/false-recording-form.component';
import { ParkerRegistrationFormComponent } from '../report/parker-registration/parker-registration-form/parker-registration-form.component';
import { TagsFormComponent } from '../report/tags/tags-form/tags-form.component';
import { AppErrorMessagesComponent } from '../../../base/error-messages/app-error-messages.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

@Component({
    selector: 'app-reports-form',
    templateUrl: './reports-form.component.html',
    styleUrls: ['./reports-form.component.scss'],
    imports: [ReactiveFormsModule, DropDownListModule, AppErrorMessagesComponent, TagsFormComponent, ParkerRegistrationFormComponent, FalseRecordingFormComponent, ParkerTurnoverFormComponent, ParkerExtractFormComponent, DeviceStatusFormComponent, TranslateModule]
})
export class ReportsFormComponent implements OnInit, OnDestroy {

  @Input() public reportsEditForm: UntypedFormGroup;

  public enumDropdownSettings = DropDownConstantsFactory.createEnumDropdownSettings();
  public types = this.enumTranslationService.translateEnum(ReportType, 'i18n.shared.reportTypes.', true);
  public ReportType = ReportType;

  private unsubscribe$ = new Subject<void>();

  constructor(private fb: UntypedFormBuilder,
              private authService: AuthService,
              private enumTranslationService: EnumTranslationService) {
  }

  public ngOnInit(): void {
    this.reportsEditForm.get('reportType').valueChanges
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe(value => {
        this.reportsEditForm.reset({reportType: value}, {emitEvent: false});
      });

    this.types = this.types.filter(type => {
      if (this.authService.getUserInfo().roles.some(r => r === Role.Admin || r === Role.ClientAdmin)) {
        return true;
      }

      if (this.authService.getUserInfo().roles.some(r => r === Role.User || r === Role.ClientUser)) {
        return type.key === ReportType[ReportType.ParkerExtract].toString();
          // || type.key === ReportType[ReportType.ParkerPerTariff].toString();
      }

      if (this.authService.getUserInfo().roles.some(r => r === Role.ParkingRanger)) {
        return type.key === ReportType[ReportType.ParkerExtract].toString()
          // || type.key === ReportType[ReportType.ParkerPerTariff].toString()
          || type.key === ReportType[ReportType.DeviceStatus].toString()
          || type.key === ReportType[ReportType.FalseRecordings].toString()
          || type.key === ReportType[ReportType.ParkerRegistrations].toString();
      }
      return false;
    });
  }

  public ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
